// extracted by mini-css-extract-plugin
export default {"input":"Select_input__J6aTs"};